import { useContext } from "react";
import Image from "next/image";

import { copyClipboard } from "@/utils/copyClipboard";
import clipIcon from "assets/icons/clip.svg";
import TaskrptNotifyUrl from "@/services/owner/task/taskrptNotifyUrl";
import { AuthContext } from "contexts/auth";

import type { TaskrptNotifySetting } from "@/types/owner/management/taskrptNotifySetting";

type Props = {
  taskId: number;
  isShareSettingView: boolean;
  taskrptNotifySetting: TaskrptNotifySetting;
  canOwnerShareLink: boolean;
  setShowShare1Modal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowShare2Modal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowShare3Modal: React.Dispatch<React.SetStateAction<boolean>>;
  setToast: React.Dispatch<React.SetStateAction<boolean>>;
};

const ShareBtn: React.FC = () => {
  return (
    <div className="absolute right-[2.75rem] top-16 -mr-3 -mt-4 w-[38px] cursor-pointer p-8 lg:w-fit">
      <Image src={clipIcon} alt="URLコピー" />
    </div>
  );
};

/* 仕事共有用のURLをコピーするボタン */
const TaskShareUrlCopyBtn: React.FC<Props> = ({
  taskId,
  isShareSettingView,
  taskrptNotifySetting,
  canOwnerShareLink,
  setShowShare1Modal,
  setShowShare2Modal,
  setShowShare3Modal,
  setToast
}) => {
  const { token } = useContext(AuthContext);

  //共有URLのコピー（判定含む）
  const judgeCopyEnabled = async () => {
    const tsk = new TaskrptNotifyUrl();
    const res = tsk.judge(
      taskrptNotifySetting,
      canOwnerShareLink,
      isShareSettingView
    );
    if (res.judgeShowShare2Modal) {
      setShowShare2Modal(true);
    } else if (res.judgeShowShare3Modal) {
      setShowShare3Modal(true);
    } else {
      //共有URL発行
      const res = await tsk.createShareUrl(token, taskId);
      if (res) {
        copyClipboard(res.url, () => setToast(true));
      }
    }
  };

  return (
    <>
      {taskrptNotifySetting?.enabled === 1 ? (
        <div
          onClick={async (e) => {
            e.preventDefault();
            await judgeCopyEnabled();
          }}
        >
          <ShareBtn />
        </div>
      ) : (
        <div
          onClick={(e) => {
            e.preventDefault();
            setShowShare1Modal(true);
          }}
        >
          <ShareBtn />
        </div>
      )}
    </>
  );
};

export default TaskShareUrlCopyBtn;
